var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSearchBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4351 10.5629H10.7124L10.4563 10.3159C11.3528 9.27301 11.8925 7.9191 11.8925 6.44625C11.8925 3.16209 9.23042 0.5 5.94625 0.5C2.66209 0.5 0 3.16209 0 6.44625C0 9.73042 2.66209 12.3925 5.94625 12.3925C7.4191 12.3925 8.77301 11.8528 9.81589 10.9563L10.0629 11.2124V11.9351L14.6369 16.5L16 15.1369L11.4351 10.5629ZM5.94625 10.5629C3.66838 10.5629 1.82962 8.72413 1.82962 6.44625C1.82962 4.16838 3.66838 2.32962 5.94625 2.32962C8.22413 2.32962 10.0629 4.16838 10.0629 6.44625C10.0629 8.72413 8.22413 10.5629 5.94625 10.5629Z",
    fill: "#A1B1CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchBold);
export default __webpack_public_path__ + "static/media/ic-search-bold.206eac1bfbc1bcf82cb4219e88f9e03b.svg";
export { ForwardRef as ReactComponent };